import { css } from '@emotion/react';

export const contentPanelHeaderStyle = css`
  padding-bottom: 0;

  > div {
    display: flex;
    align-items: flex-start;

    > div {
      flex: 1;
      overflow: hidden;
    }
  }
`;
